var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.0898438L17.91 1.49984L13.41 5.99984H17V7.99984H10V0.999844H12V4.58984L16.5 0.0898438ZM17.91 16.4998L16.5 17.9098L12 13.4098V16.9998H10V9.99984H17V11.9998H13.41L17.91 16.4998ZM1.50003 0.0898438L6.00003 4.58984V0.999844H8.00003V7.99984H1.00003V5.99984H4.59003L0.0900269 1.49984L1.50003 0.0898438ZM0.0900269 16.4998L4.59003 11.9998H1.00003V9.99984H8.00003V16.9998H6.00003V13.4098L1.50003 17.9098L0.0900269 16.4998Z",
    fill: "#629361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIcon);
export default __webpack_public_path__ + "static/media/logs-icon.4185f343760005b784818cc999e17cca.svg";
export { ForwardRef as ReactComponent };